import React from 'react';
import { Box, Typography } from '@mui/material';
import { SaveComplianceItemButton } from '../actions';
import GoBackButton from '../../../../common/components/styled-ui-elements/GoBackButton';

/**
 * ComplianceEditHeader - Header section for compliance item editing
 * Contains title, description, and action buttons
 */
export const ComplianceEditHeader: React.FC = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#ffffff',
        borderBottom: '2px solid #3b82f6',
        p: 2.5,
      }}
    >
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box>
          <Typography
            variant="h5"
            component="h1"
            fontWeight={600}
            color="#1e293b"
            sx={{ mb: 0.5 }}
          >
            Edit Compliance Requirement
          </Typography>
          <Typography
            variant="body2"
            color="#64748b"
            sx={{ fontSize: '0.9rem' }}
          >
            Update requirement details and tracking status
          </Typography>
        </Box>

        <Box display="flex" alignItems="center" gap={2}>
          <SaveComplianceItemButton label="Save Changes" successMessage="Compliance item updated successfully!" />
          <GoBackButton />
        </Box>
      </Box>
    </Box>
  );
};

export default ComplianceEditHeader;
